/**
 * @file authSlice.js
 * @author Rishikesh
 * @date 2024-09-09
 * @description Authentication management of users
 */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: null,
  ssid: null,
  candidatessid: null,
  candidateuuid: null,
  countryid: null,
  courseid: null
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    signIn: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.ssid = action.payload.ssid;
      state.candidatessid = action.payload.candidatessid;
      state.candidateuuid = action.payload.candidateuuid;
      state.countryid = action.payload.countryid;
      state.courseid = action.payload.courseid;
    },
    signOut: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.ssid = null;
      state.candidatessid = null;
      state.candidateuuid = null;
      state.countryid = null;
      state.courseid = null;
    },
  },
});

export const { signIn, signOut } = authSlice.actions;
export default authSlice.reducer;
